import {
  makeResumeUploadUpdater,
  makeGetLinkResumeUpdater,
  makeUpdateResumeUpdater,
} from 'src/components/Profile/Resume/updaters';
import { makeSuggestionsUpdater } from 'src/components/Profile/Suggestions/updaters';
import { makeTipsUpdater } from 'src/components/Profile/Tips/updaters';
import { makeUnconfirmedDataUpdater } from 'src/components/Profile/UnconfirmedData/updaters';
import {
  combineUpdaters,
  createBlendMiddleware as createMiddleware,
} from 'src/modules/redux-blend';

export const createBlendMiddleware = (deps) =>
  createMiddleware(
    combineUpdaters(
      [
        makeResumeUploadUpdater,
        makeGetLinkResumeUpdater,
        makeUpdateResumeUpdater,
        makeSuggestionsUpdater,
        makeTipsUpdater,
        makeUnconfirmedDataUpdater,
      ],
      deps,
    ),
  );
